module.exports = __webpack_public_path__ + "img/32_27.3352e2b8.png";